import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TriggersService} from "../../services/triggers.service";

@Component({
    selector: 'db-zoom-fit',
    templateUrl: './zoom-to-fit.component.html',
    styleUrl: './zoom-to-fit.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ZoomToFitComponent {
  triggersService: TriggersService = inject(TriggersService);

}
